import React from "react";
import failedImg from "../../assets/images/failed.png";
import "./PaymentSuccess.css";
import { Link } from "react-router-dom";
export function PaymentFailed(){
    return(
         <div className="paymentSuccessBg">
                 <div className="container success-container">
                   <div className="payment-content">
                       <div className="paymentImg"><img src={failedImg}/></div>
                       <div className="payment-title text-danger">Payment Failed</div>
                       <div className="payment-subtitle">Oops! Something went wrong. Please try again.</div>
                       <div className="btnPaymentBack"><Link to="/home"><button>Back To Home</button></Link></div>
       
                   </div>
       
       
       
                 </div>
               </div>
    )
}